export const TruPakMinColumnWidths = [
  // values represent pixels
  83, 83, 79, 95, 65, 50, 94, 47, 65, 78, 50, 46, 97, 82, 97,
];
